import { SmsCampaignContextForm } from "../../../../../components/secondaryComponents/SmsCampaign";

const CreateSmsCampaignContext = () => {
  return (
    <section style={{ maxWidth: "600px" }}>
      <SmsCampaignContextForm />
    </section>
  );
};

export default CreateSmsCampaignContext;
